var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('DeviseModal'),_c('TermsOfUseModal'),_c('ModalIframe'),(_vm.isNotInConfig)?_c('MainHeader'):_vm._e(),_c('div',{staticClass:"container-fluid",class:_vm.backgroundColor},[_c('router-view')],1),(_vm.isNotInConfig)?_c('MainFooter'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }